query AvailablePurchaseOrderRevisions(
  $entityDocumentId: UUID!
  $first: Int!
  $orderBy: [EntityDocumentsOrderBy!]
  $after: Cursor
  $filter: EntityDocumentFilter
) {
  availablePurchaseOrderRevisions(
    entityDocumentId: $entityDocumentId
    first: $first
    orderBy: $orderBy
    after: $after
    filter: $filter
  ) {
    nodes {
      id
      indexName
      indexReferenceNumber
      indexTransactionDate
      indexDescription
      currency {
        isoCode
      }
      indexAmount
      fileReference
      iconType
      _fileType
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
